import React from "react";
import StrategicDesign2Clean from "./StrategicDesign2Clean";

const StrategicAmbitionPage = () => {
  return (
    <div>
      <StrategicDesign2Clean />
    </div>
  );
};

export default StrategicAmbitionPage;
